<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>
                  Lesson planner
                </h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\    Lesson planner
                </div>
              </div>
              <div class="breadcrumb-right">
                <v-btn @click="addLesson()"
                       class="mt-4 btn btn-primary  mr-1"
                       dark>
                  <i class="fa fa-plus"></i>
                  Add lesson plan
                </v-btn>

              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <div class="col-md-3 ">
                  <v-select label="Course"
                            :loading="loading" clearable
                            outlined dense  v-on:keyup.enter="getLessonPlansByTeacherId"
                            :items="assigned_courses"
                            item-text="title"
                            item-value="id"
                            v-model="search.course_id">
                  </v-select>
                </div>
                <div class="col-md-3 ">
                  <v-select label="Class" clearable
                            :loading="loading"
                            outlined dense v-on:keyup.enter="getLessonPlansByTeacherId"
                            :items="academic_classes"
                            item-text="title"
                            item-value="id"
                            v-model="search.class_id">
                  </v-select>
                </div>
                <v-col cols="12" md="12" class="text-right">
                  <v-btn
                      @click="getLessonPlansByTeacherId()"
                      class="btn btn-primary btn-search "

                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
<!--                <div class="col-md-3 col-6">
                  <button class="btn btn-primary" @click="getLessonPlansByTeacherId">Filter</button>
                  <button class="btn btn-standard ml-2" @click="resetFilter">Reset</button>
                </div>-->
              </div>
            </div>
            <div class="table-responsive">
              <v-skeleton-loader
                  type="table-thead"
                  v-if="loading"
              >
              </v-skeleton-loader>

              <v-skeleton-loader
                  v-if="loading"
                  type="table-row-divider@25"
              >
              </v-skeleton-loader>
              <table class="table" v-if="!loading">
                <thead>
                <tr class="px-3">
                  <th style="max-width: 270px !important; white-space: pre-wrap;">Image</th>
                  <th>Title</th>
                  <th>Program</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th class="pr-3 text-center">Action</th>
                </tr>
                </thead>
               <tbody>
                  <tr v-show="lesson_plans.length > 0" v-for="(lesson_plan,index) in lesson_plans"
                      :key="`${lesson_plan.title}-${index}`">
                    <td style="max-width: 270px !important; white-space: pre-wrap;">
                      <v-img max-height="70" max-width="70" :src="lesson_plan.course.cover_image ? lesson_plan.course.cover_image_path['real'] :
                 'https://images.unsplash.com/photo-1627785678714-d04b8952d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=975&q=80'"
                      ></v-img>
                    </td>
                    <td>
                      <a @click="courseProgressSummary(lesson_plan)"
                         class="text-primary font-weight-bolder text-hover-primary mb-1">
                          {{ lesson_plan.title }}
                      </a>
                      <div class="text-secondary">
                        <span class="font-weight-black"> {{lesson_plan.course.title + ' - ' + lesson_plan.academic_year.title }}</span>
                      </div>
                    </td>
                    <td class="px-2">
                      <div class="text-secondary" v-if="lesson_plan.course && lesson_plan.course.program">
                        <span class="font-weight-black">Program :</span> {{ lesson_plan.course.program.title }}
                      </div>
                      <div class="text-secondary" v-if="lesson_plan.course && lesson_plan.course.grade">
                        <span class="font-weight-black">Grade :</span> {{ lesson_plan.course.grade.title }}
                      </div>
                      <div class="text-secondary" v-if="lesson_plan.academic_class && lesson_plan.academic_class.title">
                        <span class="font-weight-black">Class :</span> {{ lesson_plan.academic_class.title }}
                      </div>

                    </td>
                    <td>
                      <span class="">
                           <v-progress-linear
                               height="25"  color="blue-grey"

                               v-model="lesson_plan.lesson_completed || 0"
                           >
                             <strong>{{ lesson_plan.lesson_completed || 0 }}%</strong>
                      </v-progress-linear>
                      </span>

                    </td>
                    <td>
                      <span class="badge badge-success text-lg`"  v-if="lesson_plan.applicable_classes && lesson_plan.applicable_classes.length">
                         In Use
                      </span>
                      <span class="badge badge-danger text-lg`"  v-else>
                         Not in use
                      </span>
                    </td>
                    <td class="pr-0 text-center">
                      <template>
                        <b-dropdown
                            size="sm"
                            variant="link"
                            toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                            no-caret
                            right
                            no-flip
                        >
                          <template v-slot:button-content>
                            <i class="ki ki-bold-more-hor"></i>
                          </template>
                          <!--begin::Navigation-->
                          <div class="navi navi-hover min-w-md-250px">
                            <b-dropdown-text tag="div" class="navi-item" >
                              <a class="navi-link" @click="startLesson(lesson_plan)">
                                  <span class="navi-icon">
                                     <i class="fas fa-play"></i>
                                  </span>
                                <span class="navi-text"> Start lesson</span>
                              </a>
                            </b-dropdown-text>
                            <b-dropdown-text tag="div" class="navi-item" >
                              <a class="navi-link" @click="manage(lesson_plan)">
                                  <span class="navi-icon">
                                      <i class="fas fa-tasks"></i>
                                  </span>
                                <span class="navi-text"> Manage</span>
                              </a>
                            </b-dropdown-text>

                          </div>
                          <!--end::Navigation-->
                        </b-dropdown>
                      </template>
                    </td>
                  </tr>
                  <tr v-show="lesson_plans.length == 0">
                    <td class="text-center" colspan="5">
                      <strong>No items found.</strong>
                    </td>
                  </tr>
               </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="row mt-5" v-if="loading">
      <div class="col-md-12">
        <v-skeleton-loader
            v-bind="attrs"
            type="table"
        ></v-skeleton-loader>

      </div>
    </div>
    <div class="row mt-5" v-if="!loading && lesson_plans.length>0">
      <v-col md="4" cols="12" v-for="(lesson_plan,index) in lesson_plans"
             :key="`${lesson_plan.title}-${index}`">
        <v-card :loading="loading" class="mx-auto ">
          <v-img height="100" :src="lesson_plan.course.cover_image ? lesson_plan.course.cover_image_path['real'] :
                 'https://images.unsplash.com/photo-1627785678714-d04b8952d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=975&q=80'"
          ></v-img>
          <v-card-title>
            <router-link :to="{ name:'courses-progress-summary', params:{  lesson_plan_id:lesson_plan.id}}">
              {{ lesson_plan.title }}
            </router-link>
          </v-card-title>
          <v-progress-linear
              height="15"
              class="text-white"
              v-model="lesson_plan.lesson_completed || 0"
          >
            {{ lesson_plan.lesson_completed || 0 }}%
          </v-progress-linear>
          <v-card-text>
            <v-chip small
                    color="green"
                    class="text-white mr-2">
              {{lesson_plan.course.title + ' - ' + lesson_plan.academic_year.title }}
            </v-chip>
            <v-chip
                small
                color="green"
                class="text-white"
                v-if="lesson_plan.applicable_classes && lesson_plan.applicable_classes.length"
            >
              In Use
            </v-chip>
            <v-chip
                small
                color="red"
                class="text-white"
                v-else
            >
              Not in use
            </v-chip>
            <div class="mt-5">
              <span v-if="lesson_plan.course.program"><b>Program :</b>  {{ lesson_plan.course.program.title }} </span>
              <br>
              <span v-if="lesson_plan.course.grade"><b>Grade :</b> {{ lesson_plan.course.grade.title }}  </span><br>
              <span v-if="lesson_plan.academic_class"><b>Class :</b> {{lesson_plan.academic_class.title }} </span><br>
              <span v-if="lesson_plan.academic_class"><b>Created date :</b> {{ lesson_plan.created_at }} </span><br>
              <span v-if="lesson_plan.academic_class"><b>Updated date :</b> {{ lesson_plan.updated_at }} </span><br>
            </div>
            <v-chip-group active-class="deep-purple accent-4 white&#45;&#45;text" column>
            </v-chip-group>
            <div class="d-flex flex">
              <router-link :to="{ name:'courses-progress-summary', params:{  lesson_plan_id:lesson_plan.id}}" class="text-white btn-group-lg btn btn-primary">
                Start lesson
              </router-link>
              <router-link :to="{ name:'courses-progress-summary', params:{  lesson_plan_id:lesson_plan.id}}" class="ml-2 text-white btn-group-lg btn btn-primary">
                Manage
              </router-link>
            </div>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-col>
    </div>
    <div class="row mt-5" v-if="!loading && lesson_plans.length<1">
      <div class="col-md-12 text-center">
        <v-card class="p-20">
          <img src="@/assets/media/images/no-data-found.png">
          <h5 class="mt-10">No lesson plan available. Add new to your class.</h5>
        </v-card>
      </div>
    </div>-->
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-toolbar dark>
          <v-card-title class="headline">
            Add lesson plan
            <hr>
          </v-card-title>

          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn icon  @click="resetForm">
              <i class="fas fa-times"></i>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                  outlined
                  dense
                  v-model="lesson_planner.class_id"
                  :items="academic_classes"
                  item-text="title"
                  item-value="id"
                  label="Class"
                  return-object
                  @change="changeClass(lesson_planner.class_id)"
              >
                <!--                                        assign courses from teachers-->
              </v-select>
              <span class="text-danger" v-if="$v.lesson_planner.course_id.$error">This information is required</span>

            </v-col>
            <v-col cols="6">
              <v-select
                  outlined
                  dense
                  v-model="lesson_planner.course_id"
                  :items="assignedTeacherCourseList"
                  item-text="title"
                  item-value="id"
                  label="Course"
                  @change="__getLessonPlanner()"
              >
                <!--                                        assign courses from teachers-->
              </v-select>
              <span class="text-danger" v-if="$v.lesson_planner.course_id.$error">This information is required</span>

            </v-col>
<!--            <v-col cols="6">-->
<!--              <v-select-->
<!--                  outlined-->
<!--                  dense-->
<!--                  v-model="lesson_planner.academic_year_id"-->
<!--                  :items="academic_years"-->
<!--                  @change="__getLessonPlanner()"-->
<!--                  item-text="title"-->
<!--                  item-value="id"-->
<!--                  label="Academic Year"-->
<!--              >-->
<!--                &lt;!&ndash;                                        assign courses from teachers&ndash;&gt;-->
<!--              </v-select>-->
<!--              <span class="text-danger"-->
<!--                    v-if="$v.lesson_planner.academic_year_id.$error">Academic Year is required</span>-->
<!--            </v-col>-->
            <v-col cols="12">
              <v-select
                  outlined
                  dense
                  v-model="lesson_id"
                  :items="lesson_planners"
                  :item-text="item => item.course.title + ' - ' +item.academic_year.title + ' - ' + item.title"
                  item-value="id"
                  label="Lesson Plan"
              >
                <!--                                        assign courses from teachers-->
              </v-select>
            </v-col>

            <v-col cols="12">
              <v-text-field label="Title" v-model="lesson_planner.title" outlined dense>

              </v-text-field>
              <span class="text-danger" v-if="$v.lesson_planner.title.$error">This information is required</span>

            </v-col>

            <div class="row">
              <div class="col-12 ">

                <v-btn
                    class="text-white btn btn-primary float-right"
                    @click="__cloneLessonPlanner(lesson_id)"
                >
                  Clone
                </v-btn>

              <v-btn depressed @click="resetForm" class="text-gray btn btn-standard cancel-btn float-right">
                Cancel
              </v-btn>


              </div>
            </div>
          </v-row>
          <v-row>
            <div class="col-12" v-if="total>perPage">
              <b-pagination
                  @input="getLessonPlansByTeacherId"
                  v-model="page"
                  :total-rows="total"
                  :per-page="perPage"
                  first-number
                  last-number
              ></b-pagination>
              <!--  -->
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";
import AcademicClassTeacherService from "@/core/services/academic-class/class-teacher/AcademicClassTeacherService";
import AcademicYearService from "@/core/services/academicYear/AcademicYearService";
import LessonPlannerService from "@/core/services/lesson-planner/lesson-planner/LessonPlannerService";

const academicYearService = new AcademicYearService();
const academicClassTeacherService = new AcademicClassTeacherService();
const lessonPlannerService = new LessonPlannerService();
import GeneralMixin from "@/mixins/GeneralMixin";

export default {
  name: "index",
  validations: {
    lesson_planner: {
      course_id: {required},
      title: {required},
    }
  },
  mixins: [GeneralMixin,SiteSettingMixin],
  data() {
    return {
      dialog: false,
      attrs: '',
      loading: false,
      lesson_id: null,
      progress: 25,
      lesson_plans: [],
      assignedTeacherCourseList: [],
      academic_years: [],
      lesson_planners: [],
      page: null,
      perPage: null,
      total: null,
      lesson_planner: {
        title: '',
        academic_year_id: null,
        course_id: null,
      },
      search: {
        academic_year: null,
        program_id: null,
        grade_id: null,
        type: null,
      },
    }
  },
  mounted() {
    if(this.checkTeacherMenuAccess('lesson_planner')==false ){
      this.$router.push({name: '404'})
    }
    this.getAssignedTeacherCoursesList();
    this.getLessonPlansByTeacherId();
    this.getAcademicYears();
    this.getAssignedTeacherCourses();
    this.getAcademicClasses();
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
  },
  methods: {
    addLesson() {
      this.dialog = true;
    },
    changeClass(academic_class) {
      this.lesson_planner.class_id = academic_class.id;
      this.lesson_planner.academic_year_id = academic_class.academic_year_id;
      this.dialog = true;
    },
    getAssignedTeacherCoursesList() {
      this.loading = true;
      academicClassTeacherService.getCourseByTeacherId().then(response => {
        this.assignedTeacherCourseList = response.data.courses;
      }).catch((err) => {
        // console.log(err)
      }).finally(() => {
        this.loading = false;
      });
    },
    getLessonPlansByTeacherId() {
      this.loading = true;
      academicClassTeacherService.paginateLessonPlansByTeacherId(this.search).then(response => {
        this.lesson_plans = response.data.data;
        this.page = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.perPage = response.data.meta.per_page;
        this.loading = false;
      }).catch((err) => {
        // console.log(err)
      }).finally(() => {
        this.loading = false;

      });
    },

    resetForm() {
      this.dialog=false;
      this.$v.lesson_planner.$reset();
      this.lesson_planner = {
        title: '',
        academic_year_id: null,
        course_id: null,
      }
    },
    getAcademicYears() {
      academicYearService.all().then(response => {
        this.academic_years = response.data;
      });
    },
    __getLessonPlanner() {
      lessonPlannerService
          .paginate(this.lesson_planner)
          .then(response => {
            this.lesson_planners = response.data.data;
          })
          .catch(error => {
            // console.log(error);
          });
    },
    __cloneLessonPlanner(id) {

      this.$v.$touch();
      if (this.$v.lesson_planner.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000);
      } else {
        this.$confirm({
          message: `Do you want to clone this lesson plan ?`,
          button: {
            no: "No",
            yes: "Yes"
          },
          /**
           * Callback Function
           * @param {Boolean} confirm
           */
          callback: confirm => {
            if (confirm) {
              this.lesson_planner.added_by=this.currentUser.id;
              lessonPlannerService
                  .clone(id, this.lesson_planner)
                  .then(response => {
                    this.dialog = false;
                    this.__getLessonPlanner();
                    this.getLessonPlansByTeacherId();
                    this.$snotify.success("Cloned successfully");
                  })
                  .catch(error => {
                    //console.log(error);
                  });
            }
          }
        });
      }

    },
    resetFilter() {
      this.search = {}
      this.getLessonPlansByTeacherId()
    },
    courseProgressSummary(item){
      this.$router.push({
        name: "courses-progress-summary",
        params: { lesson_plan_id: item.id }
      });
    },
    startLesson(item){
      this.$router.push({
        name: "courses-progress-summary",
        params: { lesson_plan_id: item.id }
      });
    },
    manage(item){
      this.$router.push({
        name: "courses-progress-summary",
        params: { lesson_plan_id: item.id }
      });
    },
  },
}
</script>

<style scoped>

</style>
